"use strict";
// https://github.com/typestack/class-validator/blob/develop/src/validation/ValidationError.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.localizeErrors = localizeErrors;
var ValidationTypes;
(function (ValidationTypes) {
    ValidationTypes["WHITELIST"] = "whitelistValidation";
})(ValidationTypes || (ValidationTypes = {}));
function getParentProperty(parentProperty, property) {
    return parentProperty ? `${parentProperty}.${property}` : property;
}
function localizeErrors(messages, parentProperty = "") {
    return messages.reduce((memo, message) => {
        const constraints = message.constraints || {};
        if (ValidationTypes.WHITELIST in constraints) {
            constraints[ValidationTypes.WHITELIST] = ValidationTypes.WHITELIST;
        }
        let result = Object.assign({}, memo);
        if (Object.values(constraints)[0]) {
            const validationKey = getParentProperty(parentProperty, message.property);
            result[validationKey] = `form.validations.${Object.values(constraints)[0]}`;
        }
        if (message.children) {
            const nextParentProperty = getParentProperty(parentProperty, message.property);
            result = Object.assign(Object.assign({}, result), localizeErrors(message.children, nextParentProperty));
        }
        return result;
    }, {});
}
//# sourceMappingURL=validation.js.map